import { Box, Button, Tooltip } from "@mui/material";

interface Props {
  onRestore: () => void;
}

export default function CampaignRestoreButton({ onRestore }: Props) {
  return (
    <Tooltip title="Moves this campaign back to Active" placement="top">
      <Button
        size="small"
        variant="outlined"
        disableElevation
        onClick={(e) => {
          e.stopPropagation();
          onRestore();
        }}
        startIcon={
          <Box component="i" className="fa-regular fa-arrow-rotate-left" />
        }
        sx={{
          flexShrink: 0,
          textTransform: "none",
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 500,
          px: 1.5,
          py: 0.25,
          color: "#014638",
          borderColor: "#014638",
          "& .MuiButton-startIcon": { mr: 0.5 },
          "& .MuiButton-startIcon > *:nth-of-type(1)": { fontSize: 10 },
          "&:hover": {
            borderColor: "#014638",
            backgroundColor: "rgba(1,70,56,0.04)",
          },
        }}
      >
        Restore
      </Button>
    </Tooltip>
  );
}
